/**
 * Inverte horizontalmente uma imagem base64 (data URL).
 * Usado para desfazer o mirror da webcam na selfie enviada à biometria.
 */
export function unmirrorBase64Image(dataUrl: string): Promise<string> {
  return new Promise((resolve, reject) => {
    const img = new Image();
    img.onload = () => {
      const canvas = document.createElement("canvas");
      canvas.width = img.width;
      canvas.height = img.height;
      const ctx = canvas.getContext("2d");
      if (!ctx) {
        resolve(dataUrl);
        return;
      }
      ctx.translate(canvas.width, 0);
      ctx.scale(-1, 1);
      ctx.drawImage(img, 0, 0);
      resolve(canvas.toDataURL("image/jpeg", 0.85));
    };
    img.onerror = () => reject(new Error("Failed to unmirror image"));
    img.src = dataUrl;
  });
}

export function getValidatePhotoMessage(
  reason?: string,
  valid?: boolean,
  documentType?: "rg" | "passport" | "license"
): string {
  if (valid) {
    return "Rosto detectado com sucesso na imagem";
  }
  switch (reason) {
    case "api_error":
      return "Não foi possível verificar a imagem. Tente novamente";
    case "invalid_payload":
      return "Imagem inválida. Tire outra foto";
    case "no_face":
    default:
      if (documentType === "rg") {
        return "Não detectamos um rosto nítido no documento. Se enviou PDF da identidade digital (gov.br), confira se é o arquivo da frente com foto; ou envie foto JPG/PNG do documento";
      }
      return "Não detectamos um rosto nítido. Centralize o rosto e tire outra foto";
  }
}

export function getComparePhotoMessage(reason?: string, valid?: boolean): {
  title: string;
  description: string;
} {
  if (valid) {
    return {
      title: "Biometria confirmada",
      description: "A biometria do hóspede foi confirmada com sucesso.",
    };
  }
  switch (reason) {
    case "api_error":
      return {
        title: "Falha na verificação",
        description: "Não foi possível comparar as fotos. Tente novamente.",
      };
    case "invalid_payload":
      return {
        title: "Fotos incompletas",
        description: "Documento ou selfie ausente. Capture novamente.",
      };
    case "no_match":
    default:
      return {
        title: "Biometria não confirmada",
        description:
          "O rosto da selfie não corresponde ao do documento. Você pode tentar outra selfie ou enviar a documentação novamente, caso desconfie que a foto de documento não está clara.",
      };
  }
}
